import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";

const ThemeContext = createContext({
  isDarkMode: false,
  toggleTheme: () => { },
  primaryColor: "#3b82f6",
  setPrimaryColor: () => { },
});

export const ThemeProvider = ({ children }) => {

  /* ALWAYS DEFAULT LIGHT */
  const [isDarkMode, setIsDarkMode] = useState(() => {

    const savedTheme = localStorage.getItem("theme");

    /* IF USER ALREADY CHANGED THEME */
    if (savedTheme) {
      return savedTheme === "dark";
    }

    /* DEFAULT ALWAYS LIGHT */
    return false;

  });

  /* PRIMARY COLOR */
  const [primaryColor, setPrimaryColor] = useState(
    localStorage.getItem("primaryColor") || "#3b82f6"
  );

  /* APPLY THEME */
  useEffect(() => {

    const root = window.document.documentElement;

    if (isDarkMode) {

      root.classList.add("dark");
      localStorage.setItem("theme", "dark");

    } else {

      root.classList.remove("dark");
      localStorage.setItem("theme", "light");

    }

    /* APPLY PRIMARY COLOR */
    root.style.setProperty(
      "--primary-color",
      primaryColor
    );

  }, [isDarkMode, primaryColor]);

  /* TOGGLE THEME */
  const toggleTheme = () => {

    setIsDarkMode((prev) => !prev);

  };

  return (
    <ThemeContext.Provider
      value={{
        isDarkMode,
        toggleTheme,
        primaryColor,
        setPrimaryColor,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );

};

export const useTheme = () => useContext(ThemeContext);